import styled from 'styled-components';
export const StyledBroadsiderArticle = styled.div`
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.backgroundMenu};

  .article-container {
    margin-top: calc(-3rem - 16px);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: start;
  }

  .article-image-container {
    position: relative;
    width: 35vw;
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    margin-bottom: 4rem;
    background: ${({ theme }) => theme.mintDarkblue};
    &:hover {
      .article-image-action-hover {
        opacity: 1;
      }
    }
  }

  .article-image {
    width: 100%;
    margin-bottom: -${({ theme }) => theme.frameWidth};
    object-fit: cover;
  }

  .article-header-logo {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    width: 16rem;
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  }

  .article-header {
    width: 100%;
    height: 31.75rem;
    background-size: cover;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 7.125rem;
  }

  .article-logo-container {
    margin-top: ${({ theme }) => theme.cornerSize};
    margin-bottom: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 6rem;
    height: 6rem;
  }

  .article-image-action-hover {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    background: rgba(18, 31, 170, 0.4);
    transition: opacity linear 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  .article-image-decorator {
    position: absolute;
    top: calc(${({ theme }) => theme.cornerSize} - ${({ theme }) => theme.frameWidth});
    right: -${({ theme }) => theme.frameWidth};
    border-top: solid 2px ${({ theme }) => theme.background};
    border-bottom: solid 2px ${({ theme }) => theme.background};
    background: ${({ theme }) => theme.selection};
    width: ${({ theme }) => theme.frameWidth};
    height: 6rem;
  }

  .article-image-action-button-holder {
    width: 50%;
    min-width: 14rem
  }

  .article-image-action-button-content {
    color: white;
  }

  .article-logo {
    width: 3.5rem;
    height: 3.5rem;
  }

  .article-separator {
    width: 5vw;
    max-width: 5rem;
    height: 6rem;
    background: ${({ theme }) => theme.background};
    margin-top: ${({ theme }) => theme.cornerSize};
  }
  .article-body {
    width: 35vw;
  }
  .article-body-no-image {
    margin-top: calc(4rem + 16px);
    width: 70vw;
  }
  .article-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .article-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .article-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .article-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .article-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  .article-title-main-text {
    text-transform: uppercase;
    font-family: "NeueMachina";
    font-size: 5.5rem;
  }

  .article-title-main-text-selected {
    font-weight: 700;
  }

  .article-title-secondary-text {
    color: rgba(254, 191, 75, 1);
    font-family: "BebasNeue";
    text-transform: uppercase;
    font-weight: 700;
    font-size: 5.5rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    .article-header {
      width: 100%;
      height: 8rem;
      background-size: cover;
      padding-left: 5.125rem;
    }

    .article-header-logo {
      position: absolute;
      top: 0.25rem;
      right: 0.5rem;
      width: 8rem;
      border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    }

    .article-title-main-text {
      font-size: 2.25rem;
    }

    .article-title-secondary-text {
      font-size: 2.25rem;
    }

    .article-logo-container {
      width: 4rem;
      height: 4rem;
    }
  
    .article-logo {
      width: 2.75rem;
      height: 2.75rem;
    }
    .article-body-no-image {
      margin-top: 2rem;
      width: 100%;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .article-heading {
      font-size: 1.5rem;
     }

    .article-paragraph {
      font-size: 1rem;
      line-height: 1.5rem;
    }
    .article-logo-offset {
      margin-left: -0.5rem;
      width: 10px;
      padding-left: 0.5rem;
      background: rgba(18, 31, 170, 1);
    }
  }
`;

